<div style="position: relative;">
  <app-loader [showLoader]=showLoad></app-loader>
  <div class="c-portlet o-block u-width-100p _u-width-100p u-shadow-mini stats-container u-bg-primary lift_r5_height {{sectionclass}}">
      <!-- style="background: #cdcdcd !important; height: 100%;" -->
      <div *ngIf="hasLiftData; else noLiftDataBlock"  class="set_background_color">
          <div class="c-portlet__header o-stack o-stack--center o-stack--splitted u-px-small u-py-mini lift_quick_stacks_header">
              <div class="o-stack__cell primary-color">
                  <h5>{{sectiontitle}}</h5>
              </div>
          </div>
          <div class="analytics-portlet-content u-pt-small lift_quick_stats_portlet_content stats_content">
              <div class="o-stack o-stack--center _u-px-small lift_stats">
                  <!--  style="text-align: center"-->
                  <div class="o-stack__cell content_mainCls text_align_center" >
                      <img src="/assets/images/digitallift_r5.png" alt="lift">
                      <!--  style="display: block; font-size: 1.5em; font-weight: bold" -->
                      <span class="u-font-medium u-lh-normal u-opacity-80p stats_value lift_stats_data" 
                          *ngIf="liftStatsData">{{liftStatsData.digitalLift}}x</span>
                          <!--  style="display: block; font-size: 0.75em;"  -->
                      <span class="list_stats_name">Digital Lift</span>
                  </div>
                  <!-- style="text-align: center" -->
                  <div class="o-stack__cell content_mainCls text_align_center" >
                      <img src="/assets/images/exposed_r5.png" alt="exposed">
                      <!-- style="display: block; font-size: 1.5em; font-weight: bold" -->
                      <span  class="u-font-medium u-lh-normal u-opacity-80p stats_value lift_stats_data"
                          *ngIf="liftStatsData">{{liftStatsData.exposedRate}}%</span>
                          <!-- style="display: block; font-size: 0.75em;" -->
                      <span class="list_stats_name_ExpRate">Exposed Rate</span>
                  </div>
                  <!-- style="text-align: center" -->
                  <div class="o-stack__cell content_mainCls text_align_center" >
                      <img src="/assets/images/baselinerate_r5.png" alt="baseline">
                      <!-- style="display: block; font-size: 1.5em; font-weight: bold" -->
                      <span  class="u-font-medium u-lh-normal u-opacity-80p stats_value  lift_stats_data"
                          *ngIf="liftStatsData">{{liftStatsData.baseLineRate}}%</span>
                          <!-- style="display: block; font-size: 0.75em;" -->
                      <span class="list_stats_name" >Baseline Rate</span>
                  </div>
              </div>
              <!-- style="font-size: 1.2em; padding: 2em 0em 0.8em !important;" -->
              <div class="set_padding_r5"></div>
                      <div class="content_mainCls lift_stats_subsection lift_stats_subtitle" id="V5_lift_stats_subtitle" >People
                              who saw your digital ads were <b> <span *ngIf="liftStatsData">{{liftStatsData.digitalLift}}</span> times
                                  more likely </b>to visit your website than the unexposed audience.
                          </div>
          </div>
          <div class="no-data-container" *ngIf="!hasData">
              <div class="c-portlet o-block u-width-100p _u-width-100p u-shadow-mini stats-container u-bg-primary {{sectionclass}}">
                  <!-- style="background: #cdcdcd !important; height: 100%;" -->
                  <div class="set_background_color">
                      <div class="c-portlet__header o-stack o-stack--center o-stack--splitted u-px-small u-py-mini lift_quick_stacks_header">
                          <div class="o-stack__cell primary-color">
                              <h5>{{sectiontitle}}</h5>
                          </div>
                      </div>
                  </div>
              </div>
              <div class="map-no-data">No Data to Display</div>
          </div>
      </div>
      <ng-template #noLiftDataBlock>
          <div class="c-portlet__header o-stack o-stack--center o-stack--splitted u-px-small u-py-mini lift_quick_stacks_header no_lift_data_header">
              <div class="o-stack__cell primary-color">
                  <h5>{{sectiontitle}}</h5>
              </div>
          </div>
          <div class="analytics-portlet-content u-px-small no_lift_data_block stats_content lift_r5_nodata_content">
              <div class="lift_stats_subhead">
                  Campaigns in the selected date range are not eligible for lift reporting.
              </div>
              <div class="lift_stats_sub_section">
                  <div class="lift_stats_subhead" style="padding-top: 5px;">
                      A campaign must meet all of the following 3 requirements to receive lift reporting:
                  </div>
                  <div>
                      <ul class="lift_stats_list" >
                          <li> - Campaign must have the pixel placed and firing on the website</li>
                          <li> - Campaign must run for 3 consecutive months</li>
                          <li> - Campaign must run at least 50,000 audience extension impressions per month</li>
                      </ul>
                  </div>
              </div>
          </div>
      </ng-template>
  </div>
</div>
